class ManageStorage {
    keyData = "adoptsiStorage"
    constructor() {
        if (localStorage.getItem(this.keyData) == null) {
            const initObject = {};
            localStorage.setItem(this.keyData, JSON.stringify(initObject));
        }
    }

    get data() {
        const retrievedObject = localStorage.getItem(this.keyData);
        return JSON.parse(retrievedObject);
    }

    set items(item) {
        localStorage.setItem(this.keyData, JSON.stringify(item));
    }
}

export default ManageStorage;